(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 6839:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _components_ShopStatusPage__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5847);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2676);



var NotFound = function NotFound() {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_ShopStatusPage__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {
    message: "The page you are looking for does not exist."
  });
};

/* harmony default export */ __webpack_exports__["default"] = (NotFound);

/***/ }),

/***/ 3960:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Home; }
/* harmony export */ });
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7048);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5271);
/* harmony import */ var _components_Home_MainHome__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7208);
/* harmony import */ var _components_Loader__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4196);
/* harmony import */ var _components_StorefrontHead__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8953);
/* harmony import */ var _contexts_StoreDataContext__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7222);
/* harmony import */ var _styles_Home_module_css__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(6813);
/* harmony import */ var _styles_Home_module_css__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_styles_Home_module_css__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _utils_analytics__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8120);
/* harmony import */ var _utils_analytics__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_utils_analytics__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _utils_analyticsConfig__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1015);
/* harmony import */ var _utils_analyticsConfig__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_utils_analyticsConfig__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _404__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(6839);
/* harmony import */ var _500__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(5803);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(2676);













function Home() {
  var context = (0,_contexts_StoreDataContext__WEBPACK_IMPORTED_MODULE_5__/* .useStoreContext */ .Q)();
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
  var store = context === null || context === void 0 ? void 0 : context.storeData;
  var theme = context === null || context === void 0 ? void 0 : context.themeData;
  var error = context === null || context === void 0 ? void 0 : context.error;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true),
      loading = _useState[0],
      setLoading = _useState[1];

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if (store !== null) {
      setLoading(false);
    }
  }, [store]);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if (store && store.homeLayout !== "featured") {
      router.replace("/collections/all");
    }
  }, [store, router]); // Top of the buyer funnel. Keyed on username (no Mongo id on session).
  // Follow-up: immutable analyticsKey on Store → session.

  var storeKey = store === null || store === void 0 ? void 0 : store.username;
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if (!storeKey) return;
    (0,_utils_analytics__WEBPACK_IMPORTED_MODULE_6__.trackEvent)(_utils_analyticsConfig__WEBPACK_IMPORTED_MODULE_7__.EVENTS.STORE_VIEWED, {
      store_has_home_page: (store === null || store === void 0 ? void 0 : store.homeLayout) === "featured",
      store_product_count: Array.isArray(store === null || store === void 0 ? void 0 : store.products) ? store.products.length : undefined
    }); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [storeKey]);
  if (error && error.code === 500) return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_500__WEBPACK_IMPORTED_MODULE_9__["default"], {});
  if (error && error === 404) return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_404__WEBPACK_IMPORTED_MODULE_8__["default"], {});
  if (!store || loading) return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_components_Loader__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {});
  if (store.homeLayout !== "featured") return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_components_Loader__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {});
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
    className: (_styles_Home_module_css__WEBPACK_IMPORTED_MODULE_11___default().container),
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_components_StorefrontHead__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
      store: store
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_components_Home_MainHome__WEBPACK_IMPORTED_MODULE_2__/* .MainHome */ .q, {
      store: store,
      theme: theme
    })]
  });
}

/***/ }),

/***/ 6049:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(3960);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 6813:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"Home_container__bCOhY","cart":"Home_cart__LyzTg","about":"Home_about__6Y_1_","profilePic":"Home_profilePic__7nemD","footerTagline":"Home_footerTagline__wH1if","notFound":"Home_notFound___6xAl","notFoundMessage":"Home_notFoundMessage__KeTwU","notFoundHeadHome":"Home_notFoundHeadHome__0_jo1","link":"Home_link__mt0ji","title404":"Home_title404__7ZWAE"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [760,2455,885,1928,5813,1340,2499,3023,8112,6093,5477,9774,2888,179], function() { return __webpack_exec__(6049); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);